// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 获取vip公告 GET /vip-notice */
export async function vipNoticeUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.vipNoticeUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultVipNoticeResp>('/vip-notice', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
